import { hasPermissionOnAtLeastOneForm, hasPermissionOnAtLeastOneFormPayment, hasPermissionOnAtLeastOneFormReceipt, hasPermissionOnBank, hasPermissionOnContacts, hasPermissionOnTapToPay, hasPermissionOnUserManagement, OnboardingStep, UserRoles, } from "../enums";
import { DonorRoutes, OrganizationRoutes, RouteBuilders } from "../routes";
import { UrlBuilder } from "./url";
const campaignListUrlObject = RouteBuilders.buildCampaignListLink({
    isoLocale: null,
});
const campaignListUrl = UrlBuilder({
    pathname: campaignListUrlObject.path,
    searchParams: new URLSearchParams(campaignListUrlObject.searchParams),
}).build();
export const getDefaultDonorRoute = () => {
    return DonorRoutes.DonorPaymentTable;
};
const getDefaultRedirection = (newPermissions) => {
    if (hasPermissionOnAtLeastOneForm(newPermissions)) {
        return campaignListUrl;
    }
    if (hasPermissionOnAtLeastOneFormPayment(newPermissions)) {
        return OrganizationRoutes.Payments;
    }
    if (hasPermissionOnContacts(newPermissions)) {
        return OrganizationRoutes.Contacts;
    }
    if (hasPermissionOnBank(newPermissions)) {
        return OrganizationRoutes.Bank;
    }
    if (hasPermissionOnBank(newPermissions)) {
        return OrganizationRoutes.Bank;
    }
    if (hasPermissionOnAtLeastOneFormReceipt(newPermissions)) {
        return OrganizationRoutes.Receipts;
    }
    if (hasPermissionOnUserManagement(newPermissions)) {
        return OrganizationRoutes.Settings;
    }
    if (hasPermissionOnTapToPay(newPermissions)) {
        return OrganizationRoutes.TapToPayInvitation;
    }
    return null;
};
export const getDefaultOrganizationRouteFromNewPermissions = (newPermissions) => {
    const defaultOrganizationRoute = OrganizationRoutes.Referral;
    const { generalPermissions, formPermissions } = newPermissions || {};
    if (!newPermissions || (!generalPermissions?.length && !formPermissions?.length)) {
        return defaultOrganizationRoute;
    }
    return getDefaultRedirection(newPermissions) || defaultOrganizationRoute;
};
export const getDefaultRouteFromNewPermissions = ({ newPermissions, role, }) => {
    if (role === UserRoles.Donor) {
        return getDefaultDonorRoute();
    }
    return getDefaultOrganizationRouteFromNewPermissions(newPermissions);
};
/**
 * Returns the active onboarding step if the user hasn't completed onboarding yet.
 * Returns null if onboarding is finished or not started.
 */
export const getActiveOnboardingStep = (onboardingStep) => {
    if (!onboardingStep || onboardingStep === OnboardingStep.Finished) {
        return null;
    }
    return onboardingStep;
};
export const isInternalRedirectionUrl = ({ redirectionUrl, frontendUrl, }) => {
    if (!redirectionUrl) {
        return false;
    }
    const trimmed = redirectionUrl.trim();
    if (/^[/\\][/\\]/.test(trimmed)) {
        return false;
    }
    // Reject values containing whitespace; they are not valid redirect paths/URLs
    if (/\s/.test(trimmed)) {
        return false;
    }
    // Allow standard relative paths
    if (trimmed.startsWith("/")) {
        return true;
    }
    if (!frontendUrl) {
        return false;
    }
    try {
        const frontend = new URL(frontendUrl);
        const target = new URL(trimmed, frontend);
        // Disallow embedded credentials to avoid host-spoofing redirects
        if (target.username || target.password) {
            return false;
        }
        // Accept only same-origin absolute URLs
        return target.origin === frontend.origin;
    }
    catch {
        return false;
    }
};
